export const LOGIN = 'login'
export const SIGNUP = 'signup'
export const UPDATE_OPTION_LOGIN = 'UPDATE_OPTION_LOGIN'
export const UPDATE_OPTION_SIGNUP = 'UPDATE_OPTION_SIGNUP'
export const GOOGLE = 'Google'
export const EMAIL_PASSWORD = 'Email/Password'
